import './App.css';
import { useLocation, useNavigate} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import Loader from './components/Loader';
import InitialLoader from './components/InitialLoader';
import {useSelector} from 'react-redux';
import {ToastContainer} from 'react-toastify';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import EquipmentOutModal from './components/EquipmentOutModal';
import {
  useLazyGetOutOfServiceQuery,
} from './store/builder/inspections.api';
import {fetchAndStoreDeviceId} from './store/base.api';
import {isMobile, isTablet} from 'react-device-detect';
import MobileWarning from './components/MobileWarning/MobileWarning';
import MobileModal from './components/MobileModal/MobileModal';
import ROUTES, { isPublicPath, isResultCommentPublicPath } from './utils/routes';
import i18n, { getI18nReadyPromise } from './utils/i18n';
import { useSessionUserDetails } from './hooks/useUserDetails';
import { getOutOfServiceModalStatus, setOutOfServiceModalStatus } from './utils/tokenHandler';

function App() {
  const [equipmentOutModalStatus, setEquipmentOutModalStatus] = useState(false);
  const [i18nReady, setI18nReady] = useState(i18n.isInitialized);
  const reduxLoader = useSelector(state => state.rootReducer.reducer.loader);
  const { isLoading: sessionUserLoading } = useSessionUserDetails();
  const loader = reduxLoader || sessionUserLoading;
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const showedMobilePopup = localStorage.getItem('showedMobilePopup');
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileWarning, setMobileWarning] = useState(false);
  const [
    getOutOfService,
    {
      data: outOfServiceData,
    },
  ] = useLazyGetOutOfServiceQuery();

  const mobileLinks = [
    ROUTES.public.login,
    ROUTES.public.forgotPassword,
    ROUTES.public.enterCode,
    ROUTES.public.createPassword,
    ROUTES.public.signUp,
    ROUTES.public.registration,
    ROUTES.public.registrationCorporate,
    ROUTES.public.confirmRegistration,
    ROUTES.public.installation,
  ];

  useEffect(() => {
    if (
      isMobile &&
      !isTablet &&
      !mobileLinks.includes(location?.pathname) &&
      !isResultCommentPublicPath(location?.pathname)
    ) {
      if (!showedMobilePopup) {
        setMobileWarning(true);
      }
      localStorage.setItem('showedMobilePopup', true);
    }
  }, [location?.pathname]);

  useEffect(() => {
    if (!userInfo?.is_corporate && !userInfo?.is_regional_corporate) {
      if(userInfo) {
        getOutOfService().then((res) => {
          if(res.data?.length > 0 && getOutOfServiceModalStatus() === 'show') {
            setEquipmentOutModalStatus(true);
          } else {
            setEquipmentOutModalStatus(false);
          }
        });
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (location.pathname === ROUTES.private.main) {
      if (userInfo?.is_management || userInfo?.is_read_only) {
        navigate(ROUTES.private.logSheets);
      } else {
        navigate(ROUTES.private.inspections);
      }
    }
    if (userInfo?.is_management || userInfo?.is_read_only) {
      if (location.pathname === ROUTES.private.inspections) {
        navigate(ROUTES.private.logSheets);
      }
    }
  }, [location, userInfo]);

  useEffect(() => {
    if (userInfo?.role.name === 'translator') {
      if (userInfo?.permissions?.includes('locale_management')) {
        navigate(ROUTES.private.languageManagement);
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (!isPublicPath(location.pathname)) {
      if (userInfo?.is_admin) {
        if (userInfo?.agency?.is_settings_complete === false) {
          navigate(ROUTES.private.fboSettings);
        }
      }
    }
  }, [userInfo]);

  useEffect(() => {
    fetchAndStoreDeviceId();
  }, []);

  // Wait for i18n to be initialized before rendering app content
  useEffect(() => {
    if (!i18n.isInitialized) {
      getI18nReadyPromise().then(() => {
        setI18nReady(true);
      });
    }
  }, []);
  
  // Don't render app content until i18n is ready
  if (!i18nReady) {
    return <InitialLoader />;
  }
  
  return (
    <>
      <ToastContainer position='top-right' autoClose={5000} />
      {mobileWarning && (
        <MobileModal onClose={() => setMobileWarning(false)}>
          <MobileWarning />
        </MobileModal>
      )}
      {!mobileWarning &&
      !userInfo?.is_corporate &&
      !userInfo?.is_regional_corporate
        && (equipmentOutModalStatus &&
          outOfServiceData?.length > 0 && (
            <EquipmentOutModal
              exit={() => {
                setOutOfServiceModalStatus('hide');
                setEquipmentOutModalStatus(false);
              }}
              data={outOfServiceData}
            />
          )
        )}

      {loader && <Loader />}
    </>
  );
}

export default App;
